import React, { useState } from "react";
import './De.css'; // Your custom styles
import AppHeader from "../components/appAdminHeader/appAdminHeader";
import AppSidebar from "../components/appAdminSidebar/appAdminSidebar";
import AppadminContent from "../components/AppadminContent";

const AdminLayout = ({ setLoginStatus }) => {
  const [menuToggle, setMenuToggle] = useState(false);

  return (
    <div className="App admin-layout" style={{ overflowY: "hidden" }}>
      <AppHeader setMenuToggle={setMenuToggle} setLoginStatus={setLoginStatus} />
      
      <div className="row" style={{ height: '100vh', margin: 0 }}>
        <div className="col-2 p-0">
          <AppSidebar menuToggle={menuToggle} setMenuToggle={setMenuToggle} />
        </div>

        <div className="col-10 p-3" style={{ overflowY: "hidden" }}>
          <AppadminContent />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
